"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TranscodeProcessing = require("./TranscodeProcessing");
Object.keys(_TranscodeProcessing).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TranscodeProcessing[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TranscodeProcessing[key];
    }
  });
});